import styles from '../Tabelas.module.css'
import Container from '../../../../components/components-ui/Container/Container'
import { Table } from '../../../../components/Table'
import Button from '../../../../components/components-ui/Button/Button'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import api from '../../../../services/Api'
import Loading from '../../../../components/components-ui/Loading/Loading'

export default function Material() {
  const [listaMaterial, setListaMaterial] = useState([])
  const [showLoading, setShowLoading] = useState(false)

  useEffect(() => {
    async function getMaterial() {
      setShowLoading(true)
      const response = await api.get('/material/index')
      setListaMaterial(response.data)
      setShowLoading(false)
    }
    getMaterial()
  }, [])

  // Colunas da tabela
  const columns = [
    {
      column: 'Material',
    },
  ]

  return (
    <Container>
      <h3>Listagem de Material</h3>
      <Link to="/usina/material/novo/" style={{ display: "contents" }}>
        <Button title="Novo" type="button" />
      </Link>

      <div className={styles.content}>
        <Table edit columns={columns}>
          {listaMaterial.map(({ id_material, material }) => (
            <tr key={id_material}>
              <td>
                <Link to={`/usina/material/edit/${id_material}`}>
                  <i className="fas fa-pencil-alt"></i>
                </Link>
              </td>
              <td>{material}</td>
            </tr>
          ))}
        </Table>
        <div className={styles.loading}>
          <Loading display={showLoading ? 'block' : 'none'} />
        </div>
      </div>
    </Container>
  )
}
